import React from "react"
import { PageContext } from "."

export const usePage = () => {
    const context = React.useContext(PageContext)
    return context
}